export const brandName = 'Midad CMS';
export const mainColor = '#003399'; // #084566
export const rtl = false;